import type {
  ColumnFiltersState,
  RowSelectionState,
} from '@tanstack/react-table';
import noop from 'lodash-es/noop';
import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { createContext, useMemo } from 'react';

interface Props {
  bulkEditModalOpen: boolean;
  bulkSelectedBoostMenus: number[];
  children: ReactNode;
  columnFilters: ColumnFiltersState;
  rowSelection: RowSelectionState;
  setBulkEditModalOpen: Dispatch<SetStateAction<boolean>>;
  setBulkSelectedBoostMenus: Dispatch<SetStateAction<number[]>>;
  setColumnFilters: Dispatch<SetStateAction<ColumnFiltersState>>;
  setRowSelection: Dispatch<SetStateAction<RowSelectionState>>;
}

export const BoostMenusTableContext = createContext<Omit<Props, 'children'>>({
  bulkEditModalOpen: false,
  bulkSelectedBoostMenus: [],
  columnFilters: [],
  rowSelection: {},
  setBulkEditModalOpen: noop,
  setBulkSelectedBoostMenus: noop,
  setColumnFilters: noop,
  setRowSelection: noop,
});

export const BoostMenusTableProvider = ({
  bulkEditModalOpen,
  bulkSelectedBoostMenus,
  columnFilters,
  rowSelection,
  setBulkEditModalOpen,
  setBulkSelectedBoostMenus,
  setColumnFilters,
  setRowSelection,
  children,
}: Props) => {
  const contextValue = useMemo(
    () => ({
      bulkEditModalOpen,
      bulkSelectedBoostMenus,
      columnFilters,
      rowSelection,
      setBulkEditModalOpen,
      setColumnFilters,
      setBulkSelectedBoostMenus,
      setRowSelection,
    }),
    [
      bulkEditModalOpen,
      bulkSelectedBoostMenus,
      columnFilters,
      rowSelection,
      setBulkEditModalOpen,
      setBulkSelectedBoostMenus,
      setColumnFilters,
      setRowSelection,
    ]
  );

  return (
    <BoostMenusTableContext.Provider value={contextValue}>
      {children}
    </BoostMenusTableContext.Provider>
  );
};
